import { useQuery } from "@tanstack/react-query";
import { HistoricPaymentsResponse } from "@shared/schema";
import { apiRequest } from "@/lib/queryClient";

/**
 * Monthly income history for a PA.
 *
 * Errors are deliberately NOT swallowed. This hook used to `catch { return null }`,
 * which made a failed request indistinguishable from "this PA has earned nothing" —
 * the dashboard rendered R0 with an empty chart and, because the client defaults are
 * `retry: false` + `staleTime: 5min`, that lie stuck until a full page reload. Let the
 * query go to `isError` so callers can say so.
 */
export function useHistoricPayments(uid: string | undefined) {
  return useQuery<HistoricPaymentsResponse, Error>({
    queryKey: ["historic_payments", uid],
    enabled: !!uid,
    queryFn: async () => {
      const res = await apiRequest("GET", `/historic_payments/${uid}`);
      return res.json();
    },
  });
}
